import React from 'react';
import { Box, IconButton, CircularProgress } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import DocumentList from './DocumentList';
import FilterFAB from '../../../Components/Ui/FilterFAB';

export default function DocumentDetail({
  detailData,
  loading,
  onBack,
  onPrintClick,
  tabConfig,
  searchRef,
  custList = [],
  tabName = null,
  subMenuId = null,
  mainMenuId = null,
  onFilterClick = null,
}) {
  if (loading) {
    return (
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // detailData를 배열로 변환
  const listData = Array.isArray(detailData)
    ? detailData
    : detailData
    ? [detailData]
    : [];

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: 'background.paper',
      }}
    >
      {/* 헤더 */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          padding: '16px',
          borderBottom: '1px solid #E0E0E0',
          flexShrink: 0,
        }}
      >
        <IconButton onClick={onBack} size="small">
          <ArrowBackIcon />
        </IconButton>
        <Box sx={{ flex: 1, fontWeight: 'bold', fontSize: '18px' }}>
          {`${tabName} 상세` || '상세 정보'}
        </Box>
      </Box>

      {/* 리스트 */}
      <Box
        sx={{
          flex: 1,
          overflow: 'auto',
        }}
      >
        <DocumentList
          data={listData}
          tabConfig={tabConfig}
          onPrintClick={onPrintClick}
          searchRef={searchRef}
          custList={custList}
          tabName={tabName}
          subMenuId={subMenuId}
          mainMenuId={mainMenuId}
          isDetail={true}
        />
      </Box>

      {/* 필터 FAB - DTL 리스트에서 표시 */}
      {tabConfig?.showFilterFABInDetail && onFilterClick && (
        <FilterFAB onFilterClick={onFilterClick} />
      )}
    </Box>
  );
}
